import request from '@/utils/request'

// 获取字典数据
export function getDictData(dictKey) {
  return request({
    url: '/api/dict/list',
    method: 'get',
    params: { dict_key: dictKey }
  })
}

// 批量获取字典数据
export function getBatchDictData(dictKeys) {
  return Promise.all(dictKeys.map(key => getDictData(key)))
} 